module.exports = __webpack_public_path__ + "static/media/Avatar.8306a5a5.png";